import { ECOM_STATUS, MONTHS, TARGET_DATE, ZONE_COLORS } from './constants';
import moment from 'moment/moment';

export const randomHexColorGenerator = () => {
  const hexChars = '0123456789ABCDEF';
  let hexCode = '#';
  for (let i = 0; i < 6; i++) {
    hexCode += hexChars[Math.floor(Math.random() * 16)];
  }
  return hexCode;
};

export const timeDiffFormatForSort = (timeDiff) => {
  const regex = /(\d{1,2})\s+saat\s+(\d{1,2})\s+dakika/;
  const match = timeDiff.match(regex);
  if (match) {
    const hours = parseInt(match[1]);
    const minutes = parseInt(match[2]);
    return `${hours}.${minutes}`;
  } else {
    // Handle the case where the regex doesn't match
    return null; // or another appropriate value
  }
};

export const getZoneColor = (color) =>
  ZONE_COLORS.find((a) => a.color === color);

export function getImageSize(imageUrl) {
  return new Promise((resolve, reject) => {
    var img = new Image();
    img.src = imageUrl;

    img.onload = function () {
      var width = img.width;
      var height = img.height;
      resolve({ width, height });
    };

    img.onerror = function () {
      reject(null);
    };
  });
}

export const getZoneOptions = ({
  strokeOpacity = 1,
  strokeWeight = 2,
  strokeColor = 'black',
  fillColor = 'black',
  clickable = true,
  editable = true,
  zIndex = 1,
  fillOpacity = 0.5,
  suppressUndo = false,
} = {}) => ({
  strokeOpacity,
  strokeWeight,
  strokeColor,
  fillColor,
  clickable,
  editable,
  zIndex,
  fillOpacity,
  suppressUndo,
});

export const generateRangeWithStep = (start, end, step) => {
  let numbers = [];
  for (let i = start; i <= end; i += step) {
    numbers.push(i);
  }
  return numbers;
};

export const getColorByStatus = (status) =>
  ({
    [ECOM_STATUS.OPEN]: 'success',
    [ECOM_STATUS.CLOSED]: 'error',
    [ECOM_STATUS.TEMPORARY_CLOSED]: 'processing',
  })[status] || 'default';

export const generateMonthsFromCurrentYear = () => {
  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 1;
  const endYear = currentYear;
  const result = [];
  for (let year = startYear; year <= endYear; year++) {
    for (let month of MONTHS) {
      result.push(`${month}-${year}`);
    }
  }

  return result;
};


export const getScheduleTime = (scheduledTime, targetPlan) => {
  let utcDate = null;
  if (targetPlan === TARGET_DATE.PLANNED) {
    utcDate= moment(scheduledTime).add(3, 'hours');
  } else {
    utcDate = moment.utc().add(3, 'hours');
  }
  return utcDate.unix();
}
export const validateIdAndVKNNumber = (value, errorMessage) => {
  if (value) {
    const valueString = value.toString();
    if (!/^\d*$/.test(valueString)) {
      return Promise.reject(new Error(''));
    }
    if (valueString.length < 10 || valueString.length > 11) {
      return Promise.reject(new Error(errorMessage));
    }
  }
  return Promise.resolve();
};
